export default {
  modal: 'modal',
  advisorNote: 'advisorNote',
  advisorNoteLinkModal: 'advisorNoteLinkModal',
  createHousehold: 'createhh',
  logCall: 'logCall',
  fileViewer: 'fileViewer',
  accountAggregator: 'accountAggregator',
  managedAccounts: 'managedAccounts',
  creditCard: 'creditCard',
  postAccountCreation: 'postAccountCreation',
  clientActionItemModal: 'clientActionItem',
  actionItemList: 'actionItemList',
  householdInfo: 'householdInfo',
  household: 'household',
  goalModal: 'goalModal',
  realAssetModal: 'realAsset',
  emergencyFundModal: 'emergencyFund',
  historyFlyout: 'history',
  tasksAndTodos: 'tasksAndTodos',
  goalActionItemModal: 'goalActionItem',
  timelineNewEventDialog: 'timelineNewEventDialog',
  simpleActionItemModal: 'simpleActionItemModal',
  simpleActionItemGroupModal: 'simpleActionItemGroupModal',
  simpleActionItemLinkModal: 'simpleActionItemLinkModal',
  taskModal: 'taskModal',
  financialWellnessScoreModal: 'financialWellnessScoreModal',
  playbooksModal: 'playbooksModal',
  accountLinkingEvents: 'accountLinkingEvents',
  dependentsModal: 'dependentsModal',
  clientMeetingPreview: 'clientMeetingPreview',
  outOfOfficeModal: 'outOfOfficeModal',
  mcScheduler: 'mcScheduler',
  remindersDialog: 'remindersDialog',
  externalFormModal: 'externalForm',
  bulkCommunication: 'bulkCommunication',
  bulkCommunicationSummary: 'bulkCommunicationSummary',
  uncategorizedMeetingModal: 'uncategorizedMeetingModal',
  clientSchedulerModal: 'clientSchedulerModal',
  invoiceReceiptsModal: 'invoiceReceiptsModal',
  invoiceReceiptModal: 'invoiceReceiptModal',
  instantBookerModal: 'instantBookerModal',
  trustApproval: 'trustApproval',
  // DO NOT REMOVE - GENERATOR REPLACE ME
};
